import { createContext } from 'react';

const SearchContext = createContext({platform:'web',user:'admin'});

export default SearchContext;
